import React from 'react';
import cn from 'classnames';
import {IOption, OptionSelectedState} from '../UIOption';
import UICheckbox from '../UICheckbox';

type Props = {
  option: IOption<OptionSelectedState>
  first: boolean
  onClick: (option: IOption<OptionSelectedState>) => void
};

export default function UIMultiSelectListboxOption({
  option, first, onClick,
}: Props) {
  const handleClick = () => {
    if (option.disabled) {
      return;
    }
    onClick(option);
  };

  return (
    <div className={cn(
      'text-black hover:bg-blue-table-hover',
      {
        'border-t border-gray-light': option.parent && !first,
        'cursor-pointer': option.disabled,
        'pl-8': !option.parent,
      },
      'select-none relative py-2.5 pl-2 pr-4',
    )}>
      <span className={cn('block truncate', {
        'font-bold': option.parent,
      })}>
        <UICheckbox id={option.id} label={option.label} onChange={handleClick}
          checked={option.selected === OptionSelectedState.YES}
          indeterminate={option.selected === OptionSelectedState.PARTIALLY}/>
      </span>
    </div>
  );
}
